<template>
  <v-container>
    <v-layout row wrap justify-center>
        <v-flex xs10>
          <!-- v-expansion-panels
            accordion="true"
            focusable="true"
            v-for="(item,i) in faqData"
            :key="i"
          >
            <h1 v-if="item.parent" class="white-text text-center">{{item.parent}}</h1>
              <v-expansion-panel>
                <v-expansion-panel-header>{{item.title}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.contents"></div></v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels -->
          
          <!-- div v-for="(item,i) in faqData" :key="i">
            <h1 v-if="item.parent" class="white-text text-center">{{item.parent}}</h1>
            <h2 class="text-center white-text">{{item.title}}</h2>
            <p v-html="item.contents" class="text-center blue-text"></p>
          </div -->

<!--
          <h1>{{sectionHeader}}</h1>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(item,i) in faqData"
              :key="i"
            >
            <div>
              
            </div>
            <h1 v-if="item.parent" class="white-text text-center">{{item.parent}}</h1>
              <template v-slot:header>
                <div>{{item.title}}</div>
              </template>
              <v-card>
                <v-card-text v-html="item.contents"></v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel> -->

          <div
            v-for="(itemTop, x) in faqDataNew"
            :key="x"
          >
            <h1 class="white-text text-center">{{itemTop.parent}}</h1>
            <v-expansion-panel>
              <v-expansion-panel-content
                v-for="(item,i) in itemTop.questions"
                :key="i"
              >
                <template v-slot:header>
                  <div>{{item.title}}</div>
                </template>
                <v-card>
                  <v-card-text v-html="item.contents"></v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </div>

        </v-flex>
    </v-layout>
    <v-img
      :src="packShot"
      contain
      class="packshot-footer"
    ></v-img>   
  </v-container>
</template>

<script>
export default {
  beforeMount() {
    this.axios.get('/data/faq.json').then((response)=>{
      this.faqData = response.data.payload
    });
    this.axios.get('/data/faq-rf.json').then((response)=>{
      this.faqDataNew = response.data.payload
    });
  },
  data: () => ({
    packShot : {src:require('../assets/Packshots.png')},
    faqData: [],
    faqDataNew: []
  })
};
</script>
